import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { getBooks } from "@/lib/api";
import BookCard from "@/components/BookCard";
import Newsletter from "@/components/Newsletter";

export default function Books() {
  const [books, setBooks] = useState([]);

  useEffect(() => {
    getBooks().then(setBooks).catch(() => {});
  }, []);

  return (
    <div data-testid="books-page" className="pt-32">
      <section className="max-w-7xl mx-auto px-6 lg:px-8 pb-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl"
        >
          <p className="text-xs tracking-accent uppercase text-amber-500 mb-4">The Collection</p>
          <h1 className="font-display text-5xl sm:text-6xl font-black tracking-tight">Books</h1>
          <p className="mt-6 text-zinc-400 text-lg leading-relaxed">
            Supernatural thrillers where faith, fear, and the unexplained collide. Step into The Luminaria Chronicles.
          </p>
        </motion.div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-8 pb-28">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {books.map((b, i) => (
            <BookCard key={b.id} book={b} index={i} />
          ))}
        </div>
      </section>

      <Newsletter />
    </div>
  );
}
